<template>
  <el-table
      :data="list"
      style="width: 100%">
    <el-table-column
        prop="order_no"
        label="订单号"
        width="180">
    </el-table-column>
    <el-table-column
        prop="day_num"
        label="天">
    </el-table-column>
    <el-table-column
        prop="remark"
        label="备注"
    >
    </el-table-column>
    <el-table-column
        prop="created_at"
        label="下单时间">
    </el-table-column>
  </el-table>
</template>

<script>
import {getOrderGiveListAPI} from '../api'

export default {
  name: "orderManage",
  props: {
    uid: {
      type: [Number, String],
      default() {
        return 0
      }
    }
  },

  data() {
    return {
      list: []
    }
  },

  mounted() {
    getOrderGiveListAPI(this.uid).then(res => {
      this.list = res.data || []
    })
  },
}
</script>

<style scoped lang="scss">

</style>
